import { AsyncThunkAction, PlainAction } from 'actions/actions.types'
import { RawReceipt, Receipt } from 'api/storefront/storefront.types'

export const PAYMENT_RECEIPT = 'PAYMENT_RECEIPT' as const

export interface SetPaymentReceiptAction extends PlainAction {
  type: typeof PAYMENT_RECEIPT
  receipt: Receipt
}

export const setPaymentReceiptAction =
  (receipt: RawReceipt): AsyncThunkAction =>
  (dispatch) => {
    if (receipt) {
      const {
        url,
        amount,
        company,
        date,
        merchant_name,
        operation_type,
        transaction_id,
      } = receipt
      dispatch({
        type: PAYMENT_RECEIPT,
        receipt: {
          url,
          amount,
          company,
          date,
          merchantName: merchant_name,
          operationType: operation_type,
          transactionId: transaction_id,
        },
      })
    }

    return dispatch({
      type: PAYMENT_RECEIPT,
      receipt: null,
    })
  }
